import { TableContainer, Paper, Table, TableBody, TableRow, TableCell} from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import { currencyFormat } from "../../app/util/util";
import { Link } from "react-router-dom";


interface Props {
    subtotal?: number
}

export default function BasketSummary({subtotal}: Props) {
    
    
    const {basket} = useAppSelector(state => state.basket)

    if (subtotal === undefined) subtotal = basket?.items.reduce((sum, item) => sum + (item.price * item.quantity), 0) ?? 0;
     
    
    const deliveryFee =  720 
    
    return (
        <>
            <TableContainer component={Paper} variant={'outlined'}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={2}>Subtotal</TableCell>
                            <TableCell align="right">{currencyFormat(subtotal)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Delivery fee*</TableCell>
                            <TableCell align="right">{currencyFormat(deliveryFee)} (minimum)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Total</TableCell>
                            <TableCell align="right">{currencyFormat(subtotal+ deliveryFee)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <span style={{fontStyle: 'italic'}}>*Delivery fee will be calculated later based on your address and shipping option. You can check our <Link to='/shipping'>shipping fee policy</Link>.</span><br/><br/>
                                <span style={{fontStyle: 'italic'}}>You can check our <Link to='/refund'>Refund policy and care</Link>.</span>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}